module.exports = __webpack_public_path__ + "img/dots.4a7df97a.svg";